// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__5eYGo","collapsible":"style_collapsible__1MZIF","collapsed":"style_collapsed__1OyoZ"};